import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Entity, CacheService } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfessionalCategoryService {

  className = 'ProfessionalCategoryService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAll(cache = true, cacheKey = "allProfessionalCategories"): Observable<any[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<any[]>(environment.base_URL + "/professional-category-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newCategory(category) {
    return this.http.post(environment.base_URL + "/professional-category-types", category)
  }

  updateCategory(category, id) {
    return this.http.put(environment.base_URL + `/professional-category-types/${id}`, category)
  }
}
